import { memo } from 'react'
import { buildControlsExt, selectInput } from '../inputs/controls'
import { STATUS_FILTER } from './helpers'

interface Props {
    inputState: any
    setInputState: Function
}

export const StatusFilter = memo(function StatusFilter(props: Props) {
    const { inputState, setInputState } = props
    const options = [STATUS_FILTER.ALL, STATUS_FILTER.FAILURE, STATUS_FILTER.SUCCESS]

    const statusSelect = buildControlsExt(
        [
            selectInput({
                name: 'status',
                isLabelHidden: true,
                className: 'w-100',
                options: options,
                selected: inputState?.status ?? options[0],
            }),
        ],
        inputState,
        setInputState
    )

    return (
        <div className=" d-flex flex-column gap-1">
            <span>Status</span>
            <div className="w-100">{statusSelect}</div>
        </div>
    )
})
